import React from "react";
import { Badge } from "react-bootstrap";

const StatusBadge = ({ status }) => {
  const statusMap = {
    enviado: { variant: "info", text: "Enviado" },
    em_analise: { variant: "warning", text: "Em Análise" },
    analise_finalizada: { variant: "success", text: "Análise Finalizada" },
  };

  const statusInfo = statusMap[status] || {
    variant: "secondary",
    text: status,
  };

  return <Badge bg={statusInfo.variant}>{statusInfo.text}</Badge>;
};

export default StatusBadge;
